<template>
  <div class="more-btn">
    <div class="hover">
      <!-- 悬浮的按钮 -->
      <slot name="hoverBtn"></slot>
    </div>
    <div class="dropdown">
      <!-- 下拉框 -->
      <div class="default-dropdown">
        <div class="row">
          <span>链路速度：</span>
          <span v-text="tag.linkSpeed"></span>
        </div>
        <div class="row">
          <span>MAC：</span>
          <span v-text="tag.mac"></span>
        </div>
        <div class="row">
          <span>操作系统：</span>
          <span class="operation" v-text="tag.system"></span>
        </div>
        <div class="row">
          <span>在线时长：</span>
          <span
            v-text="onlineTimeSubtract(tag.onlineTime, tag.isOnline)"
          ></span>
        </div>
        <div class="row">
          <span>自动登录：</span>
          <span v-show="tag.autoLogin == 1">开启</span>
          <span v-show="tag.autoLogin != 1">关闭</span>
        </div>
        <div class="row">
          <span>版本：</span>
          <span v-text="tag.fversion + '<' + tag.pversion + '>'"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onlineTimeMinSec, onlineTimeSubtract } from '_slib/time'
export default {
  name: 'hoverdownleft',
  props: {
    tag: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  methods: {
    onlineTimeMinSec,
    onlineTimeSubtract,
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.more-btn {
  display: inline-block;
  position: relative;
  height: 0px;
  margin-left: 6px;
  z-index: 4;
  .hover {
    cursor: pointer;
  }
  &:hover {
    z-index: 5;
    .dropdown {
      opacity: 1;
      visibility: visible;
      z-index: 5;
    }
  }
  .dropdown {
    position: absolute;
    left: -10px;
    top: 22px;
    padding: 10px;
    visibility: hidden;
    overflow: hidden;
    min-width: 200px;
    transition: all 0.2s;
    opacity: 0;
    .default-dropdown {
      // top: -220px;
      top: 0;
      left: 0px;
      min-width: 160px;
      padding: 10px;
      padding-top: 10px;
      padding-bottom: 10px;
      .row {
        // height: 24px;
        .operation {
          width: 120px;
          line-height: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      span {
        display: inline-block;
        line-height: 20px;
      }
      span:nth-child(1) {
        width: 66px;
      }
    }
  }
}
</style>
